export const PENDING_INTAKE_BATCH_LIMIT = 50;

export function chunkPendingIntakeBatch(items, limit = PENDING_INTAKE_BATCH_LIMIT) {
  if (!Array.isArray(items) || items.length === 0) return [];
  const size = Math.max(1, limit);
  const chunks = [];
  for (let index = 0; index < items.length; index += size) {
    chunks.push(items.slice(index, index + size));
  }
  return chunks;
}
